(function () {
  'use strict';

  if (!customElements.get('parallax-hero')) {
    customElements.define(
      'parallax-hero',
      class ParallaxHero extends HTMLElement {
        defaultOptions = {
          center: true,
          round: true,
          frame: this,
        };

        constructor() {
          super();

          this.rellax = null;
          this.refreshEvent = window.theme.debounce(() => {
            this.refresh();
          }, 500);
        }

        connectedCallback() {
          const imageSelector = this.querySelector('[data-parallax-img]');
          if (!imageSelector) return;

          const speed = this.getAttribute('data-parallax-speed') || -2;
          const options = {
            ...this.defaultOptions,
            speed: parseFloat(speed),
          };

          const Rellax = window.themeRellax?.Rellax || window.Rellax;
          this.rellax = new Rellax(imageSelector, options);

          document.addEventListener('theme:resize', this.refreshEvent);

          const onLoad = () => requestAnimationFrame(() => this.refresh());
          document.readyState === 'complete' ? onLoad() : window.addEventListener('load', onLoad, {once: true});
        }

        refresh() {
          this.rellax?.refresh();
        }

        disconnectedCallback() {
          this.rellax?.destroy();
          document.removeEventListener('theme:resize', this.refreshEvent);
        }
      }
    );
  }

})();
//# sourceMappingURL=parallax-hero.js.map
